import { useRef } from 'react';
import { useFm } from '@web3/base-hooks';
import { initialWindowType } from '@/hooks/media';
import { HomeDataDTO } from '@/types/home';
import { ActiveStatus } from '@/hooks/home';
import { NoSSR } from '@web3/base-components';

import StepList from './StepList/';
import StepListH5 from './StepList/h5';
import ProjectList from './ProjectList/';

import styles from './index.module.scss';
import { RankType } from '@/constants';
import VotingPoints from './VotingPoints';

const Projects = ({
  homeData,
  activeStatus,
}: {
  homeData: HomeDataDTO;
  activeStatus: ActiveStatus;
}) => {
  const fm = useFm();
  const { isMobile } = initialWindowType;
  const topRef = useRef(null);

  return (
    <div className={styles.wrapper}>
      <div className={styles.title} ref={topRef}>
        {fm('aiDolLeaderboard')}
      </div>
      <NoSSR>
        {!isMobile ? (
          <StepList timeList={homeData?.projectTimeList} />
        ) : (
          <StepListH5 timeList={homeData?.projectTimeList} />
        )}
      </NoSSR>
      <VotingPoints
        wave1Projects={homeData?.wave1Projects}
        wave2Projects={homeData?.wave2Projects}
        projectTimeList={homeData?.projectTimeList}
      />
      <ProjectList
        rankType={RankType.POINTS}
        activeStatus={activeStatus}
        topRef={topRef}
      />
    </div>
  );
};

export default Projects;
